export default __webpack_public_path__ + "static/media/Punto_00_Finocchietti_ITA_Def.520336cc.aac";